import React, { useState, useRef } from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react-lite';

import useUser from 'hooks/use-user';
import { Clickable } from 'shared/components';

import AccountIcon from 'assets/account-icon';

import MyAccountPopover from 'components/global-header/my-account-link/my-account-popover';
import { useColors } from 'src/contexts/colors';

export const TEST_IDS = {
  myAccountIcon: `my-account-icon`,
};

export const MyAccountButton = observer(
  (): JSX.Element => {
    const [showDropdown, setShowDropdown] = useState<boolean>(false);
    const [anchorEL, setAnchorEL] = useState<HTMLElement | null | undefined>(null);
    const User = useUser();
    const isLoggedIn: boolean = User?.isLoggedIn;
    const myAccountRef = useRef<HTMLElement | null>();
    const colors = useColors();

    const toggleDropdown = (): void => {
      setAnchorEL(showDropdown ? null : myAccountRef.current);
      setShowDropdown(!showDropdown);
    };

    return (
      <Account ref={myAccountRef} onClick={toggleDropdown} data-testid={TEST_IDS.myAccountIcon}>
        <AccountIcon fill={colors.white} />
        {showDropdown && <MyAccountPopover isLoggedIn={isLoggedIn} anchorEL={anchorEL} />}
      </Account>
    );
  }
);

const Account = styled(Clickable)`
  display: flex;
  margin-right: 23px;
  svg > path {
    fill: ${({ theme }) => theme.colors.white};
  }
`;
